module.exports = __webpack_public_path__ + "static/img/6.9c03a024.jpg";